
 $(document).ready(function () {
            $('.slider-colours').slick({
                dots: false,
                 arrows: false,
                infinite: true,
                speed: 500,
                slidesToShow: 8,
               autoplay: true,
                autoplaySpeed: 3000,
                // centerMode: true,
                 centerPadding: '120px',
                slidesToScroll: 3,
                responsive: [
                  {
                    breakpoint: 1024,
                    settings: {
                      slidesToShow: 4,
                      slidesToScroll: 4,
                      infinite: true,
                       centerPadding: '60px',
                    }
                  },
                  {
                    breakpoint: 600,
                    settings: {
                      slidesToShow: 2,
                      slidesToScroll: 2,
                       centerPadding: '20px',
                    }
                  },
                  {
                    breakpoint: 480,
                    settings: {
                      slidesToShow: 3,
                      slidesToScroll: 3,
                       centerPadding: '20px',
                    }
                  }
                ]
              });
  
        });




 $(document).ready(function () {
            $('.slider-colours-free').slick({
                dots: false,
                 arrows: false,
                infinite: true,
                speed: 300,
                slidesToShow: 8,
               autoplay: true,
                autoplaySpeed: 3000,
                centerMode: true,
                 centerPadding: '120px',
                slidesToScroll: 7,
                responsive: [
                  {
                    breakpoint: 1024,
                    settings: {
                      slidesToShow: 4,
                      slidesToScroll: 4,
                      infinite: true,
                       centerPadding: '60px',
                    }
                  },
                  {
                    breakpoint: 600,
                    settings: {
                      slidesToShow: 2,
                      slidesToScroll: 2,
                       centerPadding: '20px',
                    }
                  },
                  {
                    breakpoint: 480,
                    settings: {
                      slidesToShow: 3,
                      slidesToScroll: 3,
                       centerPadding: '20px',
                    }
                  }
                ]
              });
  
        });

      
 $(document).ready(function () {
            $('.slider-reviews').slick({
                dots: false,
                arrows: false,
                infinite: true,
                speed: 8000,
                autoplay: true,
                autoplaySpeed: 0,
                cssEase: 'linear',
                slidesToShow: 1,
                centerMode: true,
                variableWidth: true
              });

        });


        $(document).ready(function () {
            $('.slider-trades').slick({
                dots: false,
                arrows: false,
                infinite: true,
                speed: 8000,
                autoplay: true,
                autoplaySpeed: 0,
                cssEase: 'linear',
                slidesToShow: 1,
                centerMode: true,
                variableWidth: true
              });

        });

 $(document).ready(function () {
            $('.slider-banner-about').slick({
                 dots: true,
                infinite: true,
                speed: 300,
                 arrows: false,
                slidesToShow: 1,
                slidesToScroll: 1,
                // autoplay: true,
                // autoplaySpeed: 5000,
              });

        });




function waitForElement(selector, callback, checkFrequency = 200, timeout = 10000) {
  const startTime = Date.now();
 
  const interval = setInterval(function () {
    if ($(selector).length && $(selector).is(':visible')) {
      clearInterval(interval);
      callback();
    } else if (Date.now() - startTime > timeout) {
      clearInterval(interval);
      console.warn("Element not found in time:", selector);
    }
  }, checkFrequency);
}
 
$(document).ready(function () {
  waitForElement('.relatedproduct-slider', function () {
    var $slider = $('.relatedproduct-slider');
 
    // Only turn this into a slick slider when there are more than 4 items.
    // 4 or fewer items just stay as a static grid (no slider behavior).
    if ($slider.children('li').length > 4) {
      $slider.slick({
        dots: false,
        arrows: true,
        infinite: true,
        speed: 300,
        slidesToShow: 4,
        slidesToScroll: 1,
        prevArrow: "<button type='button' class='slick-prev pull-left'><i class='fa fa-angle-left arrowfix' aria-hidden='true'></i></button>",
        nextArrow: "<button type='button' class='slick-next pull-right'><i class='fa fa-angle-right arrowfix' aria-hidden='true'></i></button>",
        responsive: [
          {
            breakpoint: 1024,
            settings: {
              slidesToShow: 3,
              slidesToScroll: 3,
              infinite: true,
              dots: false
            }
          },
          {
            breakpoint: 600,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 2,
              dots: false,
              arrows: false
            }
          },
          {
            breakpoint: 480,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1,
              infinite: true,
              centerMode: true,
              centerPadding: '60px',
              dots: false,
              arrows: false
            }
          }
        ]
      });
    }
  });
});





 $(document).ready(function () {
            $('.look-slider').slick({
                dots: true,
                infinite: false,
                speed: 300,
                 arrows: false,
                slidesToShow: 1,
                slidesToScroll: 1,
                autoplay: true,
                autoplaySpeed: 5000,
              });
        });



$(document).ready(function () {
   // Function to get a cookie value by name
    function getCookie(name) {
        let cookieArr = document.cookie.split(';');
        for (let i = 0; i < cookieArr.length; i++) {
            let cookie = cookieArr[i].trim();
            if (cookie.indexOf(name + "=") == 0) {
            return cookie.substring(name.length + 1, cookie.length);
            }
        }
        return "";
    }

    // Get the 'localization' cookie
    let localizationCookie = getCookie('localization');

    // You can now use this cookie value in your page
    // console.log(localizationCookie);

    if( localizationCookie !== 'GB' ){
      // console.log('It is US');
      $('.pricewithtaxUK').remove();
      $('.tax-label').not('.duty-label').remove();
      $('.price__container').remove();

      // Check if product__info-container exists and add the class NOTUK
      if ($('.product__info-container').length) {
          $('.product__info-container').removeClass('uk-area-exist');
          $('.product__info-container').addClass('not-uk');
      }
    }else{
        if ($('.product__info-container').length) {
            $('.product__info-container').addClass('uk-area-exist');
            const observer = new MutationObserver(function () {

              $('.hengam-price.hengam-final-price').each(function () {

                if ($(this).data('converted')) return;

                let priceText = $(this).text().trim();
                let price = parseFloat(priceText.replace('£', ''));

                if (!isNaN(price)) {
                  let newPrice = price * 1.2;
                  $(this).text('£' + newPrice.toFixed(2));
                  $(this).data('converted', true);
                }

              });

            });

            observer.observe(document.body, {
              childList: true,
              subtree: true
            });
            console.log("tete above fdgttt");
        }
    }
});

// home gallery 
$(document).ready(function () {
            $('.slider-colours_gl').slick({
                dots: false,
                 arrows: false,
                infinite: true,
                speed: 8000,
                slidesToShow: 6,
               autoplay: true,
                autoplaySpeed: 0,
                cssEase: 'linear',
                centerMode: true,
                 prevArrow: "<button type='button' class='slick-prev pull-left'><i class='fa fa-angle-left arrowfix' aria-hidden='true'></i></button>",
                  nextArrow: "<button type='button' class='slick-next pull-right'><i class='fa fa-angle-right arrowfix' aria-hidden='true'></i></button>",
                 centerPadding: '120px',
                slidesToScroll: 6,
                responsive: [
                  {
                    breakpoint: 1024,
                    settings: {
                      slidesToShow: 4,
                      slidesToScroll: 4,
                      infinite: true,
                       centerPadding: '60px',
                    }
                  },
                  {
                    breakpoint: 600,
                    settings: {
                      slidesToShow: 2,
                      slidesToScroll: 2,
                       centerPadding: '20px',
                    }
                  },
                  {
                    breakpoint: 480,
                    settings: {
                      slidesToShow: 3,
                      slidesToScroll: 3,
                       centerPadding: '20px',
                    }
                  }
                ]
              });
  
        });


document.addEventListener('DOMContentLoaded', function() {
    const displayBox = document.createElement('div');
    displayBox.className = 'selected-color-display';
    displayBox.style.marginTop = '10px';


    // Append below the product title
    const swatchContainer = document.querySelector('.cleartcolrsize');
    if (swatchContainer) {
      swatchContainer.appendChild(displayBox);
    }

  // Function to update color text
  function updateSelectedColor() {
    const selected = document.querySelector('input[name^="Color-"]:checked');
    if (selected) {
      displayBox.innerHTML = '<strong>Color:</strong> ' + selected.value;
    } else {
      displayBox.textContent = '';
    }
  }

  // Run on load
  updateSelectedColor();

  // Use event delegation so it still works after Shopify re-renders options
  document.addEventListener('change', function(e) {
    if (e.target.matches('input[name^="Color-"]')) {
      updateSelectedColor();
    }
  });
});




















function applyColorFilter() {
  const urlParams = new URLSearchParams(window.location.search);
  let selectedColors = urlParams.getAll("filter.v.option.color");

  if (!selectedColors || selectedColors.length === 0) return;

  selectedColors = selectedColors
    .join(",")
    .split(",")
    .map(c => c.trim().toLowerCase());

  const allItems = document.querySelectorAll(".grid__item-c2");

  allItems.forEach((item) => {
    const itemColor = item.dataset.color?.toLowerCase();
    if (itemColor && selectedColors.includes(itemColor)) {
      item.style.display = "block";
    } else {
      item.style.display = "none";
    }
  });
}


function initLoadMore(auto = false) {
  const loadMoreBtn = document.querySelector(".js-load-more");
  if (!loadMoreBtn) return;

  if (loadMoreBtn.dataset.bound === "true") return;
  loadMoreBtn.dataset.bound = "true";

  const getGrid = (root=document) =>
    root.querySelector(".product-grid") || root.querySelector(".grid--view-items");

  const detectSectionId = () => {
    const fromDom =
      getGrid()?.dataset.sectionId ||
      document.querySelector("[data-section-id]")?.value;
    if (fromDom) return fromDom;

    const nextUrlVal = document.querySelector("[data-next-url]")?.value;
    if (nextUrlVal) {
      const u = new URL(nextUrlVal, window.location.origin);
      return u.searchParams.get("section_id");
    }
    return null;
  };

  const buildNextUrl = (page) => {
    const baseVal =
      document.querySelector("[data-next-url]")?.value || window.location.href;

    const url = new URL(baseVal, window.location.origin);

    const currentParams = new URLSearchParams(window.location.search);
    currentParams.forEach((v, k) => {
      if (k !== "page") url.searchParams.set(k, v);
    });

    const sectionId = detectSectionId();
    if (sectionId && !url.searchParams.get("section_id")) {
      url.searchParams.set("section_id", sectionId);
    }

    url.searchParams.set("page", page);
    return url.toString();
  };

  function getCookie(name) {
    let cookieArr = document.cookie.split(';');
    for (let i = 0; i < cookieArr.length; i++) {
      let cookie = cookieArr[i].trim();
      if (cookie.indexOf(name + "=") == 0) {
        return cookie.substring(name.length + 1, cookie.length);
      }
    }
    return "";
  }

  function loadNextPage() {
    const totalPages = parseInt(document.querySelector("[data-total-pages]").value, 10);
    let currentPage = parseInt(document.querySelector("[data-current-page]").value, 10);

    if (currentPage >= totalPages) return;

    loadMoreBtn.disabled = true;
    const loader = loadMoreBtn.querySelector("[loader]");
    if (loader) loader.classList.remove("hidden");

    currentPage += 1;
    document.querySelector("[data-current-page]").value = currentPage;

    const nextUrl = buildNextUrl(currentPage);

    fetch(nextUrl, { method: "GET" })
      .then((res) => res.text())
      .then((responseHTML) => {
        const parser = new DOMParser();
        const doc = parser.parseFromString(responseHTML, "text/html");

        const grid = getGrid(document);
        const newGrid = getGrid(doc);

        if (grid && newGrid) {
          grid.insertAdjacentHTML("beforeend", newGrid.innerHTML);

          let localizationCookie = getCookie('localization');
          if (localizationCookie !== 'GB') {
            $('.pricewithtaxlabl .tax-label').remove();
          }

          applyColorFilter();
        }
      })
      .finally(() => {
        if (loader) loader.classList.add("hidden");
        const loadMoreText = loadMoreBtn.querySelector("[load-more-text]");
        if (loadMoreText) loadMoreText.classList.remove("hidden");

        if (currentPage < totalPages) {
          loadMoreBtn.disabled = false;
        } else {
          loadMoreBtn.classList.add("hidden");
        }
      });
  }

  if (auto) {
    const observer = new IntersectionObserver((entries) => {
      if (entries[0].isIntersecting) {
        loadNextPage();
      }
    }, { rootMargin: "200px" });
    observer.observe(loadMoreBtn);
  } else {
    loadMoreBtn.addEventListener("click", loadNextPage);
  }
}


// ── Add to Cart ────────────────────────────────────────────────────────────────
document.addEventListener('click', function(e) {
  const btn = e.target.closest('.btn-atc');
  if (!btn) return;

  const variantId = btn.dataset.variantId;
  if (!variantId) return;

  const textEl = btn.querySelector('.btn-atc-text');
  const loaderEl = btn.querySelector('.btn-atc-loader');

  // Loading state
  btn.disabled = true;
  textEl.classList.add('hidden');
  loaderEl.classList.remove('hidden');

  fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ id: variantId, quantity: 1 })
  })
  .then(res => res.ok ? res.json() : Promise.reject(res))
  .then(() => {
    btn.classList.add('success');
    textEl.textContent = 'Added!';

    const cartDrawer = document.querySelector('cart-drawer');

    if (cartDrawer) {
      fetch('/?sections=cart-drawer,cart-icon-bubble')
        .then(res => res.json())
        .then(sections => {

          // ── Refresh cart drawer contents ──────────────────────────
          if (typeof cartDrawer.renderContents === 'function') {
            cartDrawer.renderContents({
              sections: {
                'cart-drawer': sections['cart-drawer'],
                'cart-icon-bubble': sections['cart-icon-bubble']
              },
              sections_url: window.location.pathname
            });
          } else {
            // Fallback: manually inject the new HTML
            const parser = new DOMParser();
            const doc = parser.parseFromString(sections['cart-drawer'], 'text/html');
            const newDrawer = doc.querySelector('cart-drawer');
            if (newDrawer) cartDrawer.innerHTML = newDrawer.innerHTML;
          }

          // ── Remove is-empty so items are visible ──────────────────
          cartDrawer.classList.remove('is-empty');

          // ── Update cart count bubble ──────────────────────────────
          if (sections['cart-icon-bubble']) {
            const parser = new DOMParser();
            const doc = parser.parseFromString(sections['cart-icon-bubble'], 'text/html');
            const newBubble = doc.querySelector('.cart-count-bubble');
            const existingBubble = document.querySelector('.cart-count-bubble');
            if (newBubble && existingBubble) {
              existingBubble.innerHTML = newBubble.innerHTML;
            }
          }

          // ── Open the mini cart ────────────────────────────────────
          cartDrawer.open();
        });
    }
  })
  .catch(() => {
    btn.classList.add('error');
    textEl.textContent = 'Failed to add';
  })
  .finally(() => {
    textEl.classList.remove('hidden');
    loaderEl.classList.add('hidden');

    setTimeout(() => {
      btn.disabled = false;
      btn.classList.remove('success', 'error');
      textEl.textContent = 'Add to Cart';
    }, 2000);
  });
});


document.addEventListener("DOMContentLoaded", function () {
  applyColorFilter();
  initLoadMore(true);

  const observer = new MutationObserver(() => {
    initLoadMore(true);
    applyColorFilter();
  });

  const gridContainer = document.querySelector("#ProductGridContainer") || document.body;
  observer.observe(gridContainer, { childList: true, subtree: true });
});





















(function() {

  function parseMoney(str) {
    if (!str) return null;
    var cleaned = str.replace(/[^0-9.]/g, '');
    var val = parseFloat(cleaned);
    return isNaN(val) ? null : val;
  }

  function formatMoney(amount) {
    return '£' + amount.toFixed(2);
  }

  function updatePrices(wrapper) {
      var samiPrice = wrapper.querySelector('.samitaWS-customized-price');

      if (!samiPrice) return; // No Sami discount — leave everything alone

      var exclVat = parseMoney(samiPrice.textContent);
      if (exclVat === null) return;

      var inclVat = exclVat * 1.2;

      // ── Update Sami's price number but keep (Includes VAT) label ──
      var samiParent = samiPrice.closest('.price__container') || samiPrice.parentElement;

      samiPrice.textContent = formatMoney(inclVat);

      // Add (Includes VAT) label after Sami's price if not already there
      var existingLabel = samiParent.querySelector('.text-label');
      if (!existingLabel) {
          var label = document.createElement('small');
          label.className = 'text-label';
          label.textContent = '(Includes VAT)';
          samiPrice.insertAdjacentElement('afterend', label);
      }

      // ── Update your excluding VAT span ────────────────────────────
      var exclSpan = wrapper.querySelector('.price-excluding-vat');
      if (!exclSpan) return;

      var taxLabel = exclSpan.querySelector('.tax-label');
      exclSpan.textContent = formatMoney(exclVat) + ' ';
      if (taxLabel) exclSpan.appendChild(taxLabel);
  }

  function observePriceWrappers() {
    document.querySelectorAll('[id^="price-"]').forEach(function(wrapper) {
      if (wrapper.dataset.samiObserved) return;
      wrapper.dataset.samiObserved = 'true';

      var observer = new MutationObserver(function() {
        // ── Temporarily disconnect to prevent infinite loop ───────
        observer.disconnect();
        updatePrices(wrapper);
        observer.observe(wrapper, { childList: true, subtree: true, characterData: true });
      });

      observer.observe(wrapper, { childList: true, subtree: true, characterData: true });
    });
  }

  document.addEventListener('DOMContentLoaded', observePriceWrappers);

})();